<template>
  <div class="EditFormSectionComponent">
    <v-card
      class="mr-4 mb-6"
      elevation="1"
    >
      <v-card-title>
        Section {{ number + 1 }} : {{ sectionCopy.name }}
        <v-spacer />
        <v-btn
          v-if="!!number"
          title="Move Section Up"
          small
          icon
          class="move-section-up"
          color="secondary"
          @click="moveUp"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
        <v-btn
          v-if="sectionCopy.position < sectionCount - 1"
          title="Move Section Down"
          small
          icon
          class="move-section-down"
          color="secondary"
          @click="moveDown"
        >
          <v-icon>mdi-arrow-down</v-icon>
        </v-btn>
        <v-btn
          title="Delete Section"
          class="delete-section"
          text
          icon
          color="red"
          @click="deleteSection"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="8"
          >
            <v-text-field
              v-model="sectionCopy.name"
              label="Section Name"
              counter="50"
              :rules="[
                ...Rules.required,
                ...Rules.max(sectionCopy.name, 50)
              ]"
              @input="$emit('sectionUpdated', sectionCopy)"
            />
          </v-col>
        </v-row>
        <!--Section Questions -->
        <div v-if="questions.length">
          <edit-question-component
            v-for="(question, index) in questions"
            :key="index"
            :question="question"
            :number="index + 1"
            :total="questionCount"
            @moveQuestionUp="moveQuestion($event, -1)"
            @moveQuestionDown="moveQuestion($event, 1)"
            @deleteQuestion="prompt($event, 'delete')"
          />
        </div>
        <v-card
          v-else
          elevation="0"
        >
          <v-card-text class="text-center">
            This section has no questions.
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <div class="d-flex justify-center add-section">
      <v-btn
        outlined
        small
        color="secondary"
        @click="addSectionBelow()"
      >
        Add section
      </v-btn>
    </div>
    <v-dialog
      v-model="actionDialog"
      max-width="350"
      attach
    >
      <v-card>
        <v-card-title class="headline">
          Are you sure?
        </v-card-title>
        <v-card-text>
          <small>
            <b>{{ actionItem.additional_info }}</b>
          </small>
          <br>
          Are you sure you want to {{ action }} {{ actionItem.name }}?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="actionDialog = false"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="green"
            text
            @click="confirm()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'EditFormSectionComponent',
  props: {
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sectionCount: {
      type: Number,
      default: 0
    },
    number: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    action: '',
    actionDialog: false,
    actionItem: {},
    sectionCopy: {}
  }),
  computed: {
    questionCount () {
      return this.sectionCopy.questions.length
    },
    questions () {
      return _.sortBy(this.sectionCopy.questions, function (o) {
        return o.position
      })
    }
  },
  watch: {
    section (newSection, oldSection) {
      this.sectionCopy = newSection
    }
  },
  created () {
    this.sectionCopy = this.section
  },
  methods: {
    moveUp () {
      this.$emit('moveUp', this.sectionCopy)
    },
    moveDown () {
      this.$emit('moveDown', this.sectionCopy)
    },
    moveQuestion (question, shift) {
      const questionToMove = _.find(this.sectionCopy.questions, function (o) {
        return o.position === question.position
      })
      const questionToReplace = _.find(this.sectionCopy.questions, function (o) {
        return o.position === questionToMove.position + shift
      })
      questionToMove.position += shift
      questionToReplace.position += shift * -1
    },
    deleteSection () {
      this.$emit('deleteSection', this.sectionCopy)
    },
    addSectionBelow () {
      this.$emit('addSection', this.section.position)
    },
    prompt (event, action) {
      this.actionDialog = true
      this.action = action
      this.actionItem = event
      this.actionItem.name = event.question
      this.actionItem.additional_info =
        'Warning: Removing this question will also delete all answers for this question'
    },
    confirm () {
      switch (this.action) {
        case 'delete':
          this.deleteQuestion()
          break
        default:
          break
      }
    },
    deleteQuestion () {
      const self = this
      const deletedPosition = this.actionItem.position
      const indexToDelete = _.findIndex(this.sectionCopy.questions, (q) => {
        return q.position === deletedPosition
      })
      self.sectionCopy.questions.splice(indexToDelete, 1)
      this.adjustFollowingQuestionPositions(deletedPosition)
      self.actionItem = {}
      self.actionDialog = false
    },
    adjustFollowingQuestionPositions (position) {
      this.sectionCopy.questions.forEach(question => {
        if (question.position > position) {
          question.position -= 1
        }
      })
    }
  }
}
</script>
<style lang="scss">
.EditFormSectionComponent {
  & > .v-card {
    position: relative;
    padding: 1rem 1rem 2.5rem;
    background: rgba(0, 108, 223, 0.22);
  }
}
</style>
